<div class="w-full text-center mt-5">
  <img src="{{imageUrl}}" class="ml-auto mr-auto" style="width: 128px; height: 128px;">
  <h2 class="mt-2 text-2xl"><b>{{title}}</b></h2>
  <p>{{subtitle}}</p>
  <!-- <button type="button" class="btn-pill btn btn-dark btn-ts" data-toggle="modal" (click)="presentAddSection()">
  <b><i class="fa fa-plus mr-2"></i>Add Section</b>
</button> -->
</div>